/**
 * @flow
 */
'use strict';

export const prescriptionCodes = [
  {"code":"Acyclovir"},
  {"code":"Amoxicillin"},
  {"code":"Amoxicillin/Clavulanic acid"},
  {"code":"Apraclonidine"},
  {"code":"Atropine"},
  {"code":"Azithromycin"},
  {"code":"Besifloxacin"},
  {"code":"Betaxolol"},
  {"code":"Bimatoprost"},
  {"code":"Brimonidine"},
  {"code":"Brimonidine/Timolol"},
  {"code":"Brinzolamide"},
  {"code":"Carbachol"},
  {"code":"Cephalexin"},
  {"code":"Ciprofloxacin"},
  {"code":"Clarithromycin"},
  {"code":"Clindamycin"},
  {"code":"Cloxacillin"},
  {"code":"Cyclopentolate"},
  {"code":"Dexamethasone"},
  {"code":"Diclofenac"},
  {"code":"Dorzolamide"},
  {"code":"Dorzolamide/Timolol"},
  {"code":"Doxycycline"},
  {"code":"Emedastine"},
  {"code":"Erythromycin"},
  {"code":"Famciclovir"},
  {"code":"Fluorometholone"},
  {"code":"Framycetin"},
  {"code":"Framycetin/Gramicidin/Dexamethasone"},
  {"code":"Fusidic acid"},
  {"code":"Gatifloxacin"},
  {"code":"Gentamicin"},
  {"code":"Gentamicin/Betamethasone"},
  {"code":"Homatropine"},
  {"code":"Ketorolac"},
  {"code":"Ketotifen"},
  {"code":"Latanoprost"},
  {"code":"Latanoprost/Timolol"},
  {"code":"Levobunolol"},
  {"code":"Levocabastine"},
  {"code":"Levofloxacin"},
  {"code":"Lodoxamide"},
  {"code":"Loteprednol"},
  {"code":"Minocycline"},
  {"code":"Moxifloxacin"},
  {"code":"Natamycin"},
  {"code":"Nedocromil"},
  {"code":"Neomycin/Bacitracin/Polymyxin B/Hydrocortisone"},
  {"code":"Neomycin/Fluorometholone"},
  {"code":"Neomycin/Polymyxin B/Dexamethasone"},
  {"code":"Nepafenac"},
  {"code":"Ofloxacin"},
  {"code":"Olopatadine"},
  {"code":"Pilocarpine"},
  {"code":"Polymyxin B/Gramicidin/Neomycin"},
  {"code":"Polymyxin B/Neomycin/Bacitracin"},
  {"code":"Polymyxin B/Trimethoprim"},
  {"code":"Prednisolone"},
  {"code":"Rimexolone"},
  {"code":"Sulfacetamide"},
  {"code":"Sulfacetamide/Prednisolone"},
  {"code":"Tetracycline"},
  {"code":"Timolol"},
  {"code":"Tobramycin"},
  {"code":"Tobramycin/Dexamethasone"},
  {"code":"Travoprost"},
  {"code":"Travoprost/Timolol"},
  {"code":"Trifluridine"},
  {"code":"Valacyclovir"},
]
